import { SVGProps } from "react";
const Quickbooks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={60}
    viewBox="0 0 66 60"
    {...props}
  >
    <path
      fill="#22c55e"
      d="M.5 30c0 9.665 7.835 17.5 17.5 17.5h2.5V41H18c-6.075 0-11-4.925-11-11s4.925-11 11-11h6v34a6.5 6.5 0 0 0 6.5 6.5v-47H18C8.335 12.5.5 20.335.5 30zM48 12.5h-2.5V19H48c6.075 0 11 4.925 11 11s-4.925 11-11 11h-6V7A6.5 6.5 0 0 0 35.5.5v47H48c6.252 0 12.03-3.335 15.155-8.75a17.496 17.496 0 0 0 0-17.5A17.497 17.497 0 0 0 48 12.5z"
    />
  </svg>
);
export default Quickbooks;
